import React from "react";

// Same visual design as ResetPasswordStepIndicator/SignupStepIndicator, made
// generic so both the upload (4-step) and lookup (3-step) flows can share it.

export interface PaperVideoStep {
  id: string;
  label: string;
}

export default function PaperVideoStepIndicator({
  steps,
  currentStep,
}: {
  steps: PaperVideoStep[];
  currentStep: string;
}) {
  const current = steps.findIndex((s) => s.id === currentStep);

  return (
    <nav aria-label="Progress" className="mb-8">
      <ol className="flex items-center justify-between gap-2">
        {steps.map((step, index) => {
          const isComplete = index < current;
          const isCurrent = index === current;
          return (
            <li key={step.id} className="flex flex-1 flex-col items-center min-w-0">
              <div className="flex w-full items-center">
                {index > 0 && (
                  <div
                    className={`h-0.5 flex-1 ${
                      isComplete || isCurrent ? "bg-slate-800" : "bg-slate-200"
                    }`}
                  />
                )}
                <div
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                    isComplete
                      ? "bg-slate-800 text-white"
                      : isCurrent
                        ? "border-2 border-slate-800 bg-white text-slate-800"
                        : "border border-slate-300 bg-white text-slate-400"
                  }`}
                >
                  {isComplete ? "✓" : index + 1}
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`h-0.5 flex-1 ${
                      isComplete ? "bg-slate-800" : "bg-slate-200"
                    }`}
                  />
                )}
              </div>
              <span
                className={`mt-2 text-center text-xs leading-tight ${
                  isCurrent
                    ? "font-semibold text-slate-900"
                    : isComplete
                      ? "text-slate-700"
                      : "text-slate-400"
                }`}
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
